module.exports = __webpack_public_path__ + "static/media/39.85ec2ee8.jpg";